import { Separator } from "@/components/ui/baseUi/separator"
import { cn } from "@/modules/lib/utils"
import { v4 as uuidv4 } from "uuid"
import { Text } from "@/components/ui/baseUi/text"

const MAX_LINES_BEFORE_SLIPT = 8 // Maximum number of lines, after this max number, the lines will be slipted in two columns
const MAX_LINES = 20

type HuLinesProps = {
  number: number
  date: string
  className?: string
} & React.ComponentProps<"div">

/**
 * Composant for render chart with lines in the Training page
 * @param number
 * @param date
 * @returns
 */
export function HuLines({ number, date, className, ...props }: HuLinesProps) {
  const numberOfLines = number > MAX_LINES ? MAX_LINES : number

  return (
    <div className={cn("flex h-full w-1/4 flex-col items-center justify-end", className)} {...props}>
      <div className="mb-2">
        <Text fontStyle="TM" className="text-textDefault-heading">
          {number}
        </Text>
      </div>
      {number <= MAX_LINES_BEFORE_SLIPT ? (
        <div className="flex w-full flex-col gap-1">
          {Array.from({ length: numberOfLines }).map(() => (
            <Separator
              key={uuidv4()}
              orientation="horizontal"
              className="rounded-2xl bg-textDefault-heading data-[orientation=horizontal]:h-1"
            />
          ))}
        </div>
      ) : (
        <>
          <div className="flex w-full gap-1">
            <div className="flex w-1/2 flex-col gap-1">
              {Array.from({ length: Math.ceil(numberOfLines / 2) }).map(() => (
                <Separator
                  key={uuidv4()}
                  orientation="horizontal"
                  className="rounded-2xl bg-textDefault-heading data-[orientation=horizontal]:h-1"
                />
              ))}
            </div>
            <div className="flex w-1/2 flex-col-reverse gap-1">
              {Array.from({ length: Math.floor(numberOfLines / 2) }).map(() => (
                <Separator
                  key={uuidv4()}
                  orientation="horizontal"
                  className="rounded-2xl bg-textDefault-heading data-[orientation=horizontal]:h-1"
                />
              ))}
            </div>
          </div>
        </>
      )}

      <div className="mt-1">
        <Text fontStyle="BS" className="text-textDefault-heading">
          {date}
        </Text>
      </div>
    </div>
  )
}
